import React from "react";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LuxuryBackground, Card } from "../components/shared/UIComponents";

export default function PendingApproval() {
  const { user } = useAuth();
  return (
    <div className="relative" data-testid="pending-approval-page">
      <div className="relative min-h-[70vh] flex items-center justify-center">
        <LuxuryBackground />
        <div className="relative z-10 max-w-lg mx-auto px-4 sm:px-6 text-center">
          <Card hover={false}>
            <div className="py-6">
              <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-amber-100 border border-amber-200 flex items-center justify-center">
                <ShieldCheck className="h-8 w-8 text-amber-600" />
              </div>
              <h2 className="text-2xl font-semibold text-[#0A0A0A] mb-3">Account Under Review</h2>
              <p className="text-[#555] text-sm leading-relaxed mb-6">
                Thank you for registering, <span className="text-emerald-700 font-medium">{user?.full_name}</span>. Your lender account is currently being reviewed by our team. We verify all lending partners to maintain marketplace integrity.
              </p>
              <div className="rounded-xl border border-cream-warm bg-cream p-4 text-left space-y-2 mb-6">
                <div className="flex justify-between text-sm">
                  <span className="text-[#888]">Status</span>
                  <span className="text-amber-600 font-medium">Pending Approval</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-[#888]">Account</span>
                  <span className="text-[#333]">{user?.email}</span>
                </div>
              </div>
              <p className="text-xs text-[#999]">You'll receive a notification once your account has been approved. This typically takes 1-2 business days.</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
